import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-maintain',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintain.component.html',
  styleUrls: ['./maintain.component.scss']
})
export class MaintainComponent {
  maintenanceDate = '24 มีนาคม 2569';
  maintenanceTime = '08:00 น.';
  
  constructor(private router: Router) {}

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
